export const environment = {
    production: true,
    staging: false,

    api: 'https://api.id.asvz.ch/api',

    oauth2Config: {
        issuer: 'https://id.asvz.ch',
        redirectUri: 'https://id.asvz.ch/auth',
        clientId: '', //TODO
        responseType: 'code',
        scope: 'openid profile email', //offline_access api pid
        showDebugInformation: true,
        timeoutFactor: 0.01,
        checkOrigin: false,
        postLogoutRedirectUri: 'https://id.asvz.ch/logout-complete',
    },
    externalLogin: {
        idpIds: {
            // idp.asvz.ch
            eduId: '346086364019705801',
            legacyId: '346085445215471561',
        },
        successUrl: '/login/idp/success',
        failureUrl: '/login/idp/fail'
    },
    onlinedeskUrl: 'https://schalter.asvz.ch/tn/'
};